module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/sniffspot-logo-min-143.c218af43d203a2fa.png"+" 143w",
        images: [{path: "https://static.sniffspot.com/packs/img/sniffspot-logo-min-143.c218af43d203a2fa.png",width: 143,height: 143}],
        src: "https://static.sniffspot.com/packs/img/sniffspot-logo-min-143.c218af43d203a2fa.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/sniffspot-logo-min-143.c218af43d203a2fa.png"},
        
        width: 143,
        height: 143
      }